<div class="d-flex flex-column h-100">
  <ziro-top-nav [isMicrosoft360View]="true"></ziro-top-nav>
  <ziro-loading-block [hidden]="!isPageLoading"></ziro-loading-block>
  <div class="container-fluid h-100" [hidden]="isPageLoading">
    <div class="row h-100">
      <ziro-microsoft-360-detail-card
        class="col-lg-2 col-md-3 p-0"
        (viewLoaded)="setLoading($event)"
      ></ziro-microsoft-360-detail-card>
      <div
        class="col-lg-10 col-md-9 px-0 user-detail-pane"
        [class.user-detail-pane--edit-form]="isAutoAttendantEditFormActive()"
      >
        <div class="user-detail-pane__outlet">
          <ziro-breadcrumbs></ziro-breadcrumbs>
          <router-outlet></router-outlet>
        </div>
        <ziro-bottom-nav></ziro-bottom-nav>
      </div>
    </div>
  </div>
</div>
